import { minLength, maxLength } from 'react-admin'

export const length = (length, message = `Must be ${length} characters`) => [
  minLength(length, message),
  maxLength(length, message),
]

export const isInteger = (value) => {
  if (value === undefined || value === null || value === '') {
    return undefined
  }

  const integerValue = Number(value)
  const integer = Number.isInteger(integerValue) && integerValue > 0

  if (!integer) {
    return 'Must be an integer'
  }

  return undefined
}
